import { createContext, PropsWithChildren, useContext } from "react";
import { DEFAULT_TRAVELER_PICKER_CONTEXT } from "./constants";
import { TravelerPickerContextProps, TravelerPickerContextType } from "./types";

const TravelerPickerContext = createContext<TravelerPickerContextType>(
  DEFAULT_TRAVELER_PICKER_CONTEXT
);

export default function TravelerPickerProvider({
  children,
  ...props
}: PropsWithChildren<TravelerPickerContextProps>) {
  return (
    <TravelerPickerContext.Provider value={props}>
      {children}
    </TravelerPickerContext.Provider>
  );
}

export function useTravelerPicker() {
  const context = useContext(TravelerPickerContext);

  if (context === undefined) {
    throw new Error("`TravelerPickerContext` could not find any provider");
  }

  return context;
}
